export default "__VITE_ASSET__C8oXyH4J__"